import { POST } from "./api.js";

export const validationCode = {
  validateCodeFunction: (code) => POST('/validation-code/validate', code)
}